import { Bound } from "lib/@components/binding/Bound"
import { useState } from "react"
import { DifferenceWrapper } from "routes/schedule/compare/differenceWrapper"
import { Box, Stack, useTheme } from "@mui/material"
import { DifferenceTitle } from "routes/schedule/compare/difference-title"
import { ListItemBox } from "lib/@components/ListItemBox"
import { Time } from "routes/schedule/tasks/time"
import { Status } from "routes/schedule/compare/status"
import { TargetEditor } from "routes/schedule/compare/target-editor"
import { EditModeSwitch } from "routes/schedule/compare/edit-mode-switch"
import { Approved } from "routes/schedule/compare/approved"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useBoundValue } from "lib/@components/binding/use-bound-value"

export function DurationChange({ label }) {
    const { target, to } = useBoundContext()
    const [minutes, setMinutes] = useBoundValue("minutes")
    const [original] = useState(minutes)
    const [copied, setCopied] = useState(false)
    const [hover, setHover] = useState(false)
    const theme = useTheme()

    return (
        <DifferenceWrapper label={`${target.title}: ${label}`}>
            <Stack spacing={1} sx={{ width: "100%" }}>
                <DifferenceTitle label={label} />
                <ListItemBox alignItems="center">
                    <Box flex={1} sx={{ opacity: hover ? 0.25 : 1, transition: "opacity 0.2s linear", mr: -2 }}>
                        <TargetEditor>
                            <EditModeSwitch>
                                <Bound task={target}>
                                    <Time />
                                </Bound>
                            </EditModeSwitch>
                        </TargetEditor>
                    </Box>
                    <Approved>
                        <Status
                            onHover={setHover}
                            onCopyChanged={setCopied}
                            copy={copy}
                            path="minutes"
                            revert={revert}
                        />
                        <Box
                            flex={1}
                            sx={{
                                opacity: copied ? 0.5 : 1,
                                borderRadius: 1,
                                transition: "background-color linear 0.2s",
                                bgcolor: hover ? `${theme.palette.primary.main}20` : undefined,
                            }}
                        >
                            <Bound target={to} task={to} editMode={false}>
                                <Time />
                            </Bound>
                        </Box>
                    </Approved>
                </ListItemBox>
            </Stack>
        </DifferenceWrapper>
    )

    function copy() {
        setMinutes(to.minutes)
    }

    function revert() {
        setMinutes(original)
    }
}
